import { Content, PageWithHeader } from '@backstage/core-components';
import React from 'react';
import { DepartmentTreeTable } from './DepartmentTreeTable';

export const TeamsPage = () => (
  <PageWithHeader
    themeId="groups"
    title="Organization"
    pageTitleOverride="Organization"
  >
    <Content>
      {/* The teams hang off the CMDB department tree, so they are shown in it.
          The whole org is here, open four levels deep so that the operating
          units and what is below them are on screen without a click. The page
          is there to look something up in it, so the search box has the
          focus. */}
      <DepartmentTreeTable expandSpine expandLevels={4} autoFocusSearch />
    </Content>
  </PageWithHeader>
);
